import React from 'react';
import { Users, Trophy, Briefcase, GraduationCap, Heart, TrendingUp } from 'lucide-react';
import { Card } from './ui/card';

const HowWeHelp = () => {
  const programs = [
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Identificación de Talentos',
      description:
        'Realizamos scouting en provincias del interior para detectar jóvenes con potencial deportivo excepcional en fútbol y otros deportes.',
      gradient: 'from-sky-400 to-sky-600',
    },
    {
      icon: <Trophy className="w-8 h-8" />,
      title: 'Entrenamiento Profesional',
      description:
        'Acceso a entrenadores certificados, planes de desarrollo personalizados y metodologías de entrenamiento de elite.',
      gradient: 'from-blue-400 to-blue-600',
    },
    {
      icon: <Briefcase className="w-8 h-8" />,
      title: 'Infraestructura y Equipamiento',
      description:
        'Proveemos instalaciones deportivas de calidad, equipamiento profesional y recursos necesarios para el desarrollo óptimo.',
      gradient: 'from-sky-500 to-blue-600',
    },
    {
      icon: <GraduationCap className="w-8 h-8" />,
      title: 'Educación y Formación Integral',
      description:
        'Acompañamiento académico para garantizar que los atletas continúen su educación mientras persiguen sus sueños deportivos.',
      gradient: 'from-blue-500 to-sky-700',
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: 'Apoyo Psicológico y Nutricional',
      description:
        'Seguimiento profesional en salud mental, nutrición deportiva y bienestar integral para un rendimiento óptimo.',
      gradient: 'from-sky-600 to-blue-700',
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: 'Conexiones Profesionales',
      description:
        'Vinculación con clubes profesionales, agentes deportivos y oportunidades de visibilidad en competencias nacionales e internacionales.',
      gradient: 'from-blue-600 to-sky-800',
    },
  ];

  return (
    <section id="programas" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sky-600 font-semibold text-sm uppercase tracking-wide mb-2 block">
            Nuestros Programas
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Cómo Ayudamos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un enfoque integral para desarrollar atletas de elite desde el interior del país
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {programs.map((program, index) => (
            <Card
              key={index}
              className="p-8 border-2 border-gray-100 hover:border-sky-400 hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div
                className={`w-16 h-16 bg-gradient-to-br ${program.gradient} rounded-2xl flex items-center justify-center mb-6 text-white group-hover:scale-110 transition-transform duration-300`}
              >
                {program.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{program.title}</h3>
              <p className="text-gray-600 leading-relaxed">{program.description}</p>
            </Card>
          ))}
        </div>

        {/* Image Section */}
        <div className="mt-20 max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1622659097509-4d56de14539e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHNvY2NlciUyMHBsYXllcnMlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODI2ODIzNjl8MA&ixlib=rb-4.1.0&q=85"
                alt="Jóvenes en entrenamiento"
                className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
              />
            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">
                De Pueblo a Profesional
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Nuestro modelo de trabajo se enfoca en identificar talento en ciudades y pueblos del interior,
                brindándoles todas las herramientas necesarias para competir al más alto nivel.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Trabajamos principalmente con futbolistas juveniles, pero también apoyamos atletas de rugby,
                hockey, atletismo, natación y otros deportes con proyección profesional.
              </p>
              <div className="flex items-center space-x-4 pt-4">
                <div className="flex-1 h-2 bg-sky-200 rounded-full overflow-hidden">
                  <div className="h-full bg-sky-600 rounded-full" style={{ width: '85%' }}></div>
                </div>
                <span className="text-2xl font-bold text-sky-600">85%</span>
              </div>
              <p className="text-sm text-gray-500">De nuestros atletas logran firmar contratos profesionales</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
